import Cookies from 'js-cookie';
// import {LOGIN_EXPIRES_AFTER_MINUTES} from './consts';

// export const getAccessToken = () => Cookies.get('access_token');
// export const getRefreshToken = () => Cookies.get('refresh_token'); TODO: might be of great value to add a refresh token.
// export const isAuthenticated = () => !!getAccessToken();

// export const saveAccessToken = (accessToken) => {
//     const expires = ((LOGIN_EXPIRES_AFTER_MINUTES || 60) * 60) * 1000;
//     Cookies.set(
//         'access_token',
//         accessToken,
//         {
//             expires: new Date(new Date().getTime() + expires),
//             secure: process.env.NODE_ENV === 'production' ? true : false
//         }
//     );
// }

// export const removeAccessToken = () => {
// 	Cookies.remove('access_token');
// }

export const addCookie = (key, value, path, expiration) => {
    Cookies.set(
        key,
        value,
        {
            expires: expiration ? new Date(new Date().getTime() + expiration) : undefined,
            path: path
        }
    );
}

